import React from 'react';
import { Navbar } from 'react-bootstrap';

export default function BasicHeader(props) {
  return (
    <>
      <Navbar className='nav-main' expand='lg' bg='app'>
        <div className='d-flex justify-content-between align-items-center w-100'>
          <div className='nav-main-header-left-icon'></div>
          <div className='nav-main-header-text flex-grow-1'>
            <div className='nav-main-page-title'>{props.title}</div>
          </div>
          <div className='nav-main-header-right-icon'></div>
        </div>
      </Navbar>
    </>
  );
}